<template lang="pug">
  b-modal#modal-scrollable(
    v-model="show",
    ref="my-modal",
    size="lg",
    header-class="lmm-common-popup-header",
    :header-bg-variant="dialog.headerBgVariant",
    :header-text-variant="dialog.headerTextVariant",
    :body-bg-variant="dialog.bodyBgVariant",
    :body-text-variant="dialog.bodyTextVariant",
    :footer-bg-variant="dialog.footerBgVariant",
    :footer-text-variant="dialog.footerTextVariant"
    no-close-on-backdrop
    scrollable)
    template(slot="modal-header")
      img.logo(src="../../assets/main_logo.svg" style="height: 20px")
    b-container(fluid)
      h4.text-center 보안서약서
      //b-form.mt-4(@submit="onSubmit")
        b-row
          b-col(md="6")
            b-form-group(id="input-group-id" label-for="input-id")
              b-form-input(id="input-id" placeholder="아이디를 입력하세요" required)
          b-col(md="6")
            b-form-group(id="input-group-name" label-for="input-name")
              b-form-input(id="input-name" placeholder="이름을 입력하세요" required)
        b-row
          b-col(md="6")
            b-form-group(id="input-group-mail" label-for="input-email")
              b-form-input(id="input-mail" placeholder="이메일을 입력하세요" required)
          b-col(md="6")
            b-form-group(id="input-group-phone" label-for="input-phone")
              b-form-input(id="input-phone" placeholder="연락처를 입력하세요" required)
      b-row.mt-4
        b-col(md="12")
          b-card
            b-card-text
              ol
                li 상기 본인은 지정한 근무 장소에서 원격 접속을 수행한다.
                li 본인은 원격 접속 중 열람, 작성, 저장, 출력한 문서 또는 정보에 대해 철저히 관리하고, 이를 외부로 유출하지 아니한다.
                li 본인은 바이러스 감염이나 유포를 방지하기 위해서, 원격 접속 용 컴퓨터에 백신 프로그램을 설치 및 운영하며, 백신 엔진을 최신 상태로 유지한다.
                li 본인은 원격 접속 중 컴퓨터에 화면 보호 기능을 설정하고, 화면 복귀 시 반드시 비밀번호를 입력하도록 한다.
                li 본인은 원격 접속을 위해 본인에게 부여된 아이디, 비밀번호를 비롯한 보안 정보가 외부로 유출되지 않도록 철저히 관리한다.
                li 본인에게 부여된 아이디, 비밀번호를 비롯한 보안 정보가 외부로 유출되었음을 인지한 경우 즉시 사용 정지 신청을 하고, 이를 재발급 받도록 한다.
                li 본인은 허가되지 않은 임의의 파일 전송이나 화면 캡쳐, 녹화와 같은 행위를 일절하지 않으며, 필요시 적절한 보안 체계를 갖추고 상위 관리자에게 보고 후 수행한다.
              b 본인은 상기와 같은 사항을 준수하며, 이를 위반한 때에는 사규 및 관련 법령에 따라 처벌 및 불이익을 감수할 것을 서약합니다.
            b-card
              h6.text-center
                |{{dialog.setToday}}
      //div.footer.d-flex.justify-content-around
        b-button.mt-4.col-md-5(
          size="md",
          variant="primary",
          @click="onSubmit"
        ) {{$t('security-access')}}
        b-button.mt-4.col-md-5(
          size="md",
          @click="close"
        ) {{$t('reject')}}
    template(slot="modal-footer")
      b-button.btn(
        width="100",
        size="md",
        variant="primary",
        @click="onSubmit"
      ) {{$t('security-access')}}
      b-button.btn(
        size="md",
        @click="close"
      ) {{$t('reject')}}
</template>

<script>
import _ from 'lodash'

const defaultValues = {
  size: 'lg',
  title: '',
  context: '',
  sort: '',
  headerBgVariant: 'light',
  headerTextVariant: 'dark',
  bodyBgVariant: 'light',
  bodyTextVariant: 'dark',
  footerBgVariant: 'light',
  footerTextVariant: 'dark',
  align: 'center',
  setToday: ''
}
export default {
  name: 'security-dialog',
  methods: {
    focusIn () {
      this.$refs.close.focus()

      // b-modal속성 @shown="focusIn"
    },
    close () {
      this.show = false
    },
    onSubmit () {
      this.show = false
      this.cb('submit')
    },
    getToday () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      // var today = mm + '/' + dd + '/' + yyyy
      var todaySet = yyyy + '년 ' + mm + '월 ' + dd + '일'

      setTimeout (() => {
        this.dialog.setToday = todaySet
      }, 100)
    }
  },
  created () {
    this.dialog = defaultValues
    this.AppState.$on('show-security-dialog', (data, cb) => {
      this.dialog = _.assignIn({}, defaultValues, data)
      if (typeof cb === 'function') this.cb = cb
      this.show = true
    })

    this.getToday()
  },
  data () {
    return {
      show: false,
      dialog: {},
      cb () {}
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
<style lang="scss" scoped>
  .modal-footer {
    justify-content: space-around !important;
    .btn {
      width: 100%;
    }
  }
</style>
